// Query-param gate for previews and targeted testing.
export const isCustomizeEnabled = (searchParams: URLSearchParams): boolean =>
  searchParams.get('customize') === '1';
